import React, { useState } from 'react';
import logo from '../../Assets/logoblack.png'
import classes from './Navigation.module.css'
import { Link } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { PopupButton } from "react-calendly";

export default function Navigation() {



  // const values = [true, 'sm-down', 'md-down', 'lg-down', 'xl-down', 'xxl-down'];
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [fullName, setFullName] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };


  function handleShow(breakpoint) {
    setFullscreen(breakpoint);
    setShow(true);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    // Split full name into first and last name
    const [firstName, ...rest] = fullName.trim().split(' ');
    const lastName = rest.join(' ');

    // Now you can use firstName and lastName as needed
    console.log('First Name:', firstName);
    console.log('Last Name:', lastName);

    // ...handle the rest of your form submission
  };

  

  return (
    <div className={classes.stickyNav}>
      <div className={classes.navigation}>
        <header className={classes.header}>
          <Link to={'/'} > <img src={logo} className={classes.logo} /></Link>
          <button className={classes.hamburger} onClick={toggleMenu}>
            ☰
          </button>
          <div className={`${classes.navbar} ${isMenuOpen ? classes.show : ''}`}>
            <li>
              <Link to={'/'} className={classes.navtxt}>Home</Link>
            </li>
            <li>
              <Link to={'/about_us#'} className={classes.navtxt}>About</Link>
            </li>
            <li>
              <Link to={'/blog'} className={classes.navtxt}>Blog</Link>
            </li>

            {/* Mobile button */}

            {/* <Button onClick={() => handleShow(true)} className={classes.navbtnmble}>Book a Call</Button> */}
            <PopupButton
              url="https://calendly.com/scaleworkflow/30min?background_color=009562&text_color=ffffff&primary_color=1a1a1a" style="min-width:320px;height:700px;"
              rootElement={document.getElementById("root")}
              text="Book a Call"
              className={classes.navbtnmble}
            />
          </div>

          {/* Web button */}
          {/* <Button onClick={() => handleShow(true)} className={classes.navbtn}>Book a Call</Button> */}
          <PopupButton
            url="https://calendly.com/scaleworkflow/30min?background_color=009562&text_color=ffffff&primary_color=1a1a1a" style="min-width:320px;height:700px;"
            rootElement={document.getElementById("root")}
            text="Book a Call"
            className={classes.navbtn}
          />

          <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)} className={classes.modal}>
            <Modal.Header style={{ borderBottom: 'none', marginRight: '4.5rem' }} closeButton>
              <Modal.Title ></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className={classes.modalcontainer}>
                <div className={classes.modalhead}>
                  <p className={classes.knowutxt}>Let’s know how we can be helpful!</p>
                  <p className={classes.fillfrmtxt}>Fill the form and provide the right information to get you started.</p>
                </div>
                <form className={classes.form} onSubmit={handleSubmit}>
                  <div className={classes.inputcontainer}>
                    <label htmlFor="name" className={classes.flnm}>Full name</label>
                    <input type="text" name="fullName" placeholder='Name' required value={fullName}
                      onChange={e => setFullName(e.target.value)} />
                  </div>
                  <div className={classes.inputcontainer}>
                    <label htmlFor="email" className={classes.flnm}>Email address</label>
                    <input type="email" placeholder='Email' required />
                  </div>
                  <div className={classes.inputcontainer}>
                    <label htmlFor="phone" className={classes.flnm}>Phone number</label>
                    <input type="text" placeholder='Phone Number' required />
                  </div>
                  <div className={classes.inputcontainer}>
                    <label htmlFor="message" className={classes.flnm}>Type your message here</label>
                    <textarea placeholder='Message' required />
                  </div>
                  <Button variant="primary" type="submit" className={classes.submitbtn}>
                    Send a Message
                  </Button>
                </form>
              </div></Modal.Body>
          </Modal>
        </header>
      </div>
    </div>
  );
}

